"use strict";
exports.__esModule = true;
var zlib = null;
try {
    zlib = require('zlib');
}
catch (err) {
    // Ignore
}
function getCompressionFunc() {
    if (zlib) {
        return zlib.gzipSync;
    }
    else {
        return null;
    }
}
exports["default"] = getCompressionFunc;
